import serverProps from '../utils/serverProps'
import { ActionTypes as types } from '../constants'

const { recipientData: { group: { name, id } = {} } = {} } = serverProps

const initialState = {
  name,
  id,
}

export default (state = initialState, action) => {
  if (action.type === types.TRANSACTION.CANCELLED_TRANSACTION) {
    return {}
  }
  if (action.type === types.TRANSACTION.LEAVING_SUCCESS_PAGE) {
    return {}
  }
  return state
}
